/**
 * ISSUE B — a viewer-INDEPENDENT number for a bot seat.
 *
 * Every table used to number its opponent bots RELATIVE to the local player's own seat
 * (`(seat - you + n) % n`), so the SAME bot read as «حریف ۳» to one human and «حریف ۱» to their
 * friend — two people at one table could not talk about "حریف ۱" and mean the same chair.
 *
 * The number now comes from the bot's ABSOLUTE position among the bot seats: the bot at the
 * lowest seat is 1, the next is 2, and so on. The set of bot seats is the SAME for everyone (it
 * is derived from the shared server roster — a seat holds a human or it does not, regardless of
 * who is looking), so this ordinal is identical on every screen. A human's own seat is never a
 * bot seat, so which chair is "you" does not shift the numbering.
 *
 * `isBot(seat)` is the per-game predicate for "this seat has no real human" — usually
 * `players[seat]` being absent / flagged a bot. For a partnership game (hokm/شلم) pass a
 * predicate that is true only for the OPPONENT bot seats, so the two opponents number 1..2 by
 * absolute seat while the partner keeps its «هم‌تیمی» role label.
 *
 * @returns the 1-based ordinal (never 0 — the old `faNum(seat)` could print «حریف ۰»).
 */
export function botOrdinal(seat: number, seats: number, isBot: (s: number) => boolean): number {
  let n = 0;
  for (let s = 0; s < seats; s += 1) {
    if (isBot(s)) {
      n += 1;
      if (s === seat) return n;
    }
  }
  return n || 1; // `seat` wasn't flagged a bot — defensively return a sane 1-based value
}
